import React, { useState, useEffect, useRef } from "react";

import axios from "axios";

// MUI Imports
import {
  Button,
  TextField,
  InputAdornment,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Box,
  Grid,
  Tooltip,
  IconButton,
  Typography,
  Modal,
} from "@mui/material";

import {
  defualtErrorMessage,
  graphColorList,
  defaultGraphStyle,
  defaultAllTickersOptions,
  frequencyList,
  defaultFrequency,
  modalDarkTheme,
  defaultSelectedTickers,
  tickerPattern,
  graphDateFormat,
  tickerCategoryList,
} from "../common/common-variables";
import {
  searchAllTickers,
  getAllData,
  calculateScale,
  getMinMaxDateAllTickers,
} from "../apis/analysis-apis";
import PreLoader from "../components/loader";
import TickerRow from "../components/ticker-row";
import TickerCategoryTabs from "../components/ticker-category-tabs";

// MUI Icons
import SearchIcon from "@mui/icons-material/Search";

const TickerModal = () => {
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [selectedTickerCategory, setSelectedTickerCategory] = useState("All");
  const [tickerOptions, setTickersOptions] = useState([]);
  const [searchedTicker, setSearchedTicker] = useState(null);
  const [isTickerSearching, setIsTickerSearching] = useState(false);

  const handleOpen = (e, isPrimaryClicked) => {

    setShowSearchModal(true);
  };
  const handleClose = () => setShowSearchModal(false);

  let typingTimeout = null; // Declare a variable to store the timeout ID
  let cancelTokenSource = null; // Axios cancel token source

  useEffect(() => {
    const search_terms = searchedTicker?.trim() || "";
    const params = {
      search_terms,
      ticker_types: [selectedTickerCategory],
    };

    // Clear the previous timeout if the user is still typing
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // If a previous API call exists, cancel it before making a new one
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Operation canceled due to new request.");
    }

    // Create a new cancel token source for the new request
    cancelTokenSource = axios.CancelToken.source();

    // Set a new timeout to wait 1 second after the user stops typing
    typingTimeout = setTimeout(() => {
      setIsTickerSearching(true);
      searchAllTickers(params, { cancelToken: cancelTokenSource.token })
        .then((resp) => {
          setTickersOptions(resp?.data.result);
          setIsTickerSearching(false);
        })
        .catch((err) => {
          setIsTickerSearching(false);
          if (axios.isCancel(err)) {
          } else {
          }
        });
    }, 1000); // Delay of 1000 = 1 second

    // Cleanup function to clear timeout and cancel the previous API call
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
      if (cancelTokenSource) {
        cancelTokenSource.cancel("Cleanup: Canceling previous request.");
      }
    };
  }, [searchedTicker, selectedTickerCategory]);

  const handleClickTickerSelect = (e, newValue) => {
    // redirect to dashboard with newvalue
    newValue.isPrimary = true;
    const url = `/users/workspace/react-dashboard/?selected_tickers=${encodeURIComponent(
      JSON.stringify([newValue])
    )}`;
    window.location.href = url;
  };

  const handleChangeCategory = (event, newValue) => {
    setSelectedTickerCategory(newValue);
  };
  const handleChangeTickerSearch = (event) => {
    setSearchedTicker(event.target.value);
  };
  return (
    <>
      <Box sx={{ cursor: "pointer" }} onClick={handleOpen}>
        <Tooltip title="Search Tickers">
          <Box // Wrap the TextField to ensure the click triggers
            sx={{
              background: "grey",
              borderRadius: "25px",
              cursor: "pointer",
              "& .MuiOutlinedInput-root": {
                pointerEvents: "none", // Disables pointer events on the TextField itself
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  borderColor: "transparent",
                },
                paddingLeft: "8px",
              },
            }}
          >
            <TextField
              variant="outlined"
              placeholder="Search..."
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                style: {
                  color: "white",
                },
              }}
            />
          </Box>
        </Tooltip>
      </Box>

      <Modal
        open={showSearchModal}
        onClose={handleClose}
        aria-labelledby="select-columns-modal-title"
        aria-describedby="select-columns-modal-description"
        sx={modalDarkTheme.modal}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
          sx={modalDarkTheme.modalContent}
        >
          <Typography
            id="select-columns-modal-title"
            variant="h6"
            component="h2"
            gutterBottom
          >
            Search Ticker
          </Typography>

          <Box>
            <input
              id="search-column-input"
              type="text"
              placeholder="Enter Ticker"
              className="modal-input"
              onChange={() => handleChangeTickerSearch(event)}
            />
          </Box>

          <Box
            sx={{
              mt: "1rem",
              mb: "1rem",
            }}
          >
            <TickerCategoryTabs
              tickerCategoryList={tickerCategoryList}
              selectedTickerCategory={selectedTickerCategory}
              handleChangeCategory={handleChangeCategory}
            />
          </Box>

          {isTickerSearching ? (
            <div className="loader-container">
              {" "}
              <PreLoader />{" "}
            </div>
          ) : (
            <Box
              sx={{
                backgroundColor: "#1b1b1b",
                borderRadius: "8px",
                width: "100%",
                maxHeight: "30vh",
                mt: "1rem",
                overflowY: "auto",
              }}
            >
              {tickerOptions.map((ticker, idx) => (
                <TickerRow
                  key={idx}
                  ticker={ticker}
                  handleClickTickerSelect={handleClickTickerSelect}
                />
              ))}
            </Box>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default TickerModal;
